import React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from '@mui/icons-material/Share';

//Custom Components
import TableButton from "./TableButton";

//Types
import { ITableActionButtonDetail } from "@/@types/ui/Table";

function TableButtonShareExcursion(props: ITableActionButtonDetail) {
  const { t } = useTranslation();

  return (
    <TableButton startIcon={<ShareIcon/>} allow="one" selection={[]} {...props}>
     {t('buttons.share_excursion')}
    </TableButton>
  );
}

export default TableButtonShareExcursion;
